export default {
  // Basic data
  companyId: '',
  companyName: '',

  // Owner change data
  prevCustomerId: '',
  takeoverDate: '',
  
  // Contact data
  contactName: '',
  contactPhone: '',
  contactEmail: '',
  contactEmailConfirmation: '',

  // Operation data
  companyFriendlyName: '',
  legalOwnerName: '',
  outletType: '',
  season: 'fullYear',
  eventStartDate: '',
  eventEndDate: '',
  openHourStart: '',
  openHourEnd: '',
  
  // Delivery data
  deliveryAddress: '',
  deliveryZipCode: '',
  deliveryCity: '',
  deliveryDay: '',
  deliveryPeriod: '',
  deliveryNotes: '',
  
  // Mailing data
  diffAddrForMail: false,
  mailAddress: '',
  mailZipCode: '',
  mailCity: '',
  
  // Payment data
  invoiceEmail: '',
  enableEamElectronicInvoice: false,
  paymentRemindersEmail: '',

  checkTOS: false,
  checkPaymentTerms: false,
  checkNewsletterSubscription: false,
  checkSmsReminder: false,
  checkMarketingCommunication: false
};
